<template>
  <div class="topbar-item">
    <div
      class="btn btn-icon w-auto btn-clean d-flex align-items-center btn-lg px-2"
      id="kt_quick_user_toggle"
    >
      <span
        class="text-muted font-weight-bold font-size-base d-none d-md-inline mr-1"
      >
        {{ $t("hi") }},
      </span>
      <span
        class="text-dark-50 font-weight-bolder font-size-base d-none d-md-inline mr-3"
      >
        {{ currentUserFirstName }}
      </span>
      <span class="symbol symbol-35 symbol-light-success">
        <img
          v-if="hasCurrentUserPhoto"
          alt="Pic"
          :src="currentUserProfileImage"
        />
        <span
          v-if="!hasCurrentUserPhoto"
          class="symbol-label font-size-h5 font-weight-bold"
        >
          {{ currentUserSymbol }}
        </span>
      </span>
    </div>

    <div
      id="kt_quick_user"
      ref="kt_quick_user"
      class="offcanvas offcanvas-right p-10"
    >
      <!--begin::Header-->
      <div
        class="offcanvas-header d-flex align-items-center justify-content-between pb-5"
      >
        <h3 class="font-weight-bold m-0">
          {{ $t("userProfile") }}
          <small class="text-muted font-size-sm ml-2">{{
            $t("messageCount")
          }}</small>
        </h3>
        <a
          href="#"
          class="btn btn-xs btn-icon btn-light btn-hover-primary"
          id="kt_quick_user_close"
        >
          <i class="ki ki-close icon-xs text-muted"></i>
        </a>
      </div>
      <!--end::Header-->

      <!--begin::Content-->
      <perfect-scrollbar
        class="offcanvas-content pr-5 mr-n5 scroll"
        style="max-height: 90vh; position: relative"
      >
        <!--begin::Header-->
        <div class="d-flex align-items-center mt-5">
          <div class="symbol symbol-100 mr-5">
            <img
              v-if="hasCurrentUserPhoto"
              class="symbol-label"
              :src="currentUserProfileImage"
              alt=""
            />
            <span
              v-if="!hasCurrentUserPhoto"
              class="symbol-label bg-success font-size-h5 font-weight-bold"
            >
              {{ currentUserSymbol }}
            </span>
            <i class="symbol-badge bg-success"></i>
          </div>
          <div class="d-flex flex-column">
            <router-link
              to="/custom-pages/profile"
              class="font-weight-bold font-size-h5 text-dark-75 text-hover-primary"
            >
              {{ currentUserFullName }}
            </router-link>
            <div class="text-muted mt-1">{{ currentUserTitle }}</div>
            <div class="navi mt-2">
              <a href="#" class="navi-item">
                <span class="navi-link p-0 pb-2">
                  <span class="navi-icon mr-1">
                    <span class="svg-icon svg-icon-lg svg-icon-primary">
                      <!--begin::Svg Icon-->
                      <inline-svg
                        src="media/svg/icons/Communication/Mail-notification.svg"
                      />
                      <!--end::Svg Icon-->
                    </span>
                  </span>
                  <span class="navi-text text-muted text-hover-primary">
                    {{ currentUserEmail }}
                  </span>
                </span>
              </a>
            </div>
            <button class="btn btn-light-primary btn-bold" @click="onLogout">
              {{ $t("logout") }}
            </button>
          </div>
        </div>
        <!--end::Header-->
        <div class="separator separator-dashed mt-8 mb-5"></div>
        <!--begin::Nav-->
        <div class="navi navi-spacer-x-0 p-0">
          <!--begin::Item-->
          <router-link
            to="/builder"
            @click.native="closeOffcanvas"
            href="#"
            class="navi-item"
          >
            <div class="navi-link">
              <div class="symbol symbol-40 bg-light mr-3">
                <div class="symbol-label">
                  <span class="svg-icon svg-icon-md svg-icon-success">
                    <!--begin::Svg Icon-->
                    <inline-svg
                      src="media/svg/icons/General/Notification2.svg"
                    />
                    <!--end::Svg Icon-->
                  </span>
                </div>
              </div>
              <div class="navi-text">
                <router-link :to="{ name: 'myProfileInformation' }">
                  <div class="font-weight-bold">{{ $t("myProfile") }}</div>
                </router-link>
                <div class="text-muted">
                  {{ $t("myProfileDesc") }}
                </div>
              </div>
            </div>
          </router-link>
          <!--end:Item-->
          <!--begin::Item-->
          <router-link
            v-for="(item, index) in userPanelMenuItems"
            :key="index"
            :to="{ name: item.route }"
            @click.native="closeOffcanvas"
            href="#"
            class="navi-item"
          >
            <div class="navi-link">
              <div class="symbol symbol-40 bg-light mr-3">
                <div class="symbol-label">
                  <span class="svg-icon svg-icomd svg-icon-warning">
                    <!--begin::Svg Icon-->
                    <img v-if="item.svg != null" :src="item.svg" />
                    <!--end::Svg Icon-->
                  </span>
                </div>
              </div>
              <div class="navi-text">
                <div class="font-weight-bold">{{ $t(item.label) }}</div>
                <div class="text-muted">{{ $t(item.description) }}</div>
              </div>
            </div>
          </router-link>
          <!--end:Item-->
        </div>
        <!--end::Nav-->
        <div
          v-if="hasUserPanelExtraComponent"
          class="separator separator-dashed my-7"
        ></div>
        <keep-alive>
          <component v-bind:is="userPanelExtraComponent"></component>
        </keep-alive>
      </perfect-scrollbar>
      <!--end::Content-->
    </div>
  </div>
</template>

<style lang="scss" scoped>
#kt_quick_user {
  overflow: hidden;
}
</style>

<script>
import { mapGetters } from "vuex";
import KTLayoutQuickUser from "@/assets/js/layout/extended/quick-user.js";
import KTOffcanvas from "@/assets/js/components/offcanvas.js";

export default {
  name: "KTQuickUser",
  data() {
    return {
      list: [
        {
          title: "Another purpose persuade",
          desc: "Due in 2 Days",
          alt: "+28%",
          svg: "media/svg/icons/Home/Library.svg",
          type: "warning"
        },
        {
          title: "Would be to people",
          desc: "Due in 2 Days",
          alt: "+50%",
          svg: "media/svg/icons/Communication/Write.svg",
          type: "success"
        },
        {
          title: "Purpose would be to persuade",
          desc: "Due in 2 Days",
          alt: "-27%",
          svg: "media/svg/icons/Communication/Group-chat.svg",
          type: "danger"
        },
        {
          title: "The best product",
          desc: "Due in 2 Days",
          alt: "+8%",
          svg: "media/svg/icons/General/Attachment2.svg",
          type: "info"
        }
      ]
    };
  },
  mounted() {
    // Init Quick User Panel
    KTLayoutQuickUser.init(this.$refs["kt_quick_user"]);
  },
  methods: {
    onLogout() {
      this.$store
        .dispatch("logout")
        .then(() => this.$router.push({ name: "login" }));
    },
    closeOffcanvas() {
      new KTOffcanvas(KTLayoutQuickUser.getElement()).hide();
    }
  },
  computed: {
    ...mapGetters([
      "currentUserSymbol",
      "currentUserFullName",
      "currentUserFirstName",
      "hasCurrentUserPhoto",
      "currentUserProfileImage",
      "currentUserEmail",
      "currentUserTitle",
      "userPanelMenuItems",
      "hasUserPanelExtraComponent",
      "userPanelExtraComponent"
    ])
  }
};
</script>

<i18n>
{
  "tr": {
    "hi": "Merhaba",
    "userProfile": "Kullanıcı Profili",
    "logout": "Güvenli Çıkış",
    "messageCount": "12 Mesaj",
    "myProfile": "Profilim",
    "myProfileDesc": "Profil bilgilerinizi buradan güncelleyebilirsiniz."
  },
  "en": {
    "hi": "Hi",
    "userProfile": "User Profile",
    "logout": "Logout",
    "messageCount": "12 Message",
    "myProfile": "My Profile",
    "myProfileDesc": "Account Informations"
  }
}
</i18n>
